module.exports = __webpack_public_path__ + "img/8.54b1de8b.jpg";